var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"percent-tag",class:{
    'percent-tag--red': _vm.red || (_vm.red === undefined && _vm.real > _vm.planned),
    'percent-tag--grey': !_vm.planned
  }},[(_vm.planned)?[_vm._v(_vm._s(_vm.percent)+"%")]:[_vm._v("div0")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }